import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fromCity: '',
    toCity: '',
};

const citySlice = createSlice({
    name: 'cities',
    initialState,
    reducers: {
        setCities(state, action) {
            const { fromCity, toCity } = action.payload;
            state.fromCity = fromCity;
            state.toCity = toCity;
        },
    },
});

export const { setCities } = citySlice.actions;

export default citySlice.reducer;
